/*
 * Ziyaret bildirimi: site açılınca backend'e haber verir, backend de
 * Telegram'a yazar. Ziyaretçi proje sayfalarını gezdikçe ve CV'yi açtıkça
 * aynı Telegram mesajı güncellenir.
 *
 * Kaynak etiketi: onurcinkaya.cv/?k=wa gibi linklerle gelinirse "wa" okunur
 * ve adres çubuğundan silinir (paylaşılan linke taşınmasın).
 *
 * Kendi ziyaretlerini saymamak için bir kez onurcinkaya.cv/?ben=1 aç;
 * geri almak için ?ben=0.
 */

import { API_URL } from "./api";

const store = {
  get(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* gizli sekme vb. — takip yine çalışır, sadece hatırlamaz */
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* yok say */
    }
  },
};

const OWNER_KEY = "oc-ben";
const ID_KEY = "oc-ziyaretci";
const LAST_KEY = "oc-son-ziyaret";
const COUNT_KEY = "oc-ziyaret-sayisi";
const VISIT_GAP_MS = 30 * 60 * 1000; // backend'deki 30 dk ile aynı

let visitorId = null;
let started = false;
let lastPage = null;

function isOwner() {
  return store.get(OWNER_KEY) === "1";
}

/* npm start ile yerelde açılan site yayındaki backend'e gider; geliştirirken
   Telegram'a sahte ziyaret düşmesin. Yerel backend kullanılıyorsa açık. */
const isLocalDev =
  /^(localhost|127\.0\.0\.1|192\.168\.)/.test(window.location.hostname) &&
  !process.env.REACT_APP_API_URL;

function send(olay, detay = "", extra = {}) {
  if (!visitorId || isOwner() || isLocalDev) return;
  try {
    fetch(`${API_URL}/ziyaret`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ziyaretci: visitorId, olay, detay, ...extra }),
      keepalive: true, // sayfa kapansa da istek gitsin
    }).catch(() => {});
  } catch {
    /* takip asla siteyi bozmamalı */
  }
}

/* Uygulama açılınca bir kez çağrılır. */
export function startVisit(firstPage) {
  if (started) return;
  started = true;

  const url = new URL(window.location.href);
  const ben = url.searchParams.get("ben");
  if (ben === "1") store.set(OWNER_KEY, "1");
  if (ben === "0") store.remove(OWNER_KEY);
  const kaynak = url.searchParams.get("k") || "";

  if (url.searchParams.has("k") || url.searchParams.has("ben")) {
    url.searchParams.delete("k");
    url.searchParams.delete("ben");
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);
  }

  if (isOwner()) return;

  visitorId = store.get(ID_KEY);
  if (!visitorId) {
    visitorId = Math.random().toString(36).slice(2) + Date.now().toString(36);
    store.set(ID_KEY, visitorId);
  }

  // Yeni bir ziyaret mi (30 dk'dan uzun ara), yoksa sayfa yenileme mi?
  const now = Date.now();
  const last = Number(store.get(LAST_KEY) || 0);
  let count = Number(store.get(COUNT_KEY) || 0);
  if (now - last > VISIT_GAP_MS) {
    count += 1;
    store.set(COUNT_KEY, String(count));
  }
  store.set(LAST_KEY, String(now));

  lastPage = firstPage;
  let tz = "";
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    /* eski tarayıcı */
  }
  const d = new Date();
  send("giris", firstPage, {
    kaynak,
    referrer: document.referrer || "",
    dil: navigator.language || "",
    ekran: `${window.screen.width}x${window.screen.height}`,
    tz,
    yerel_saat: `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`,
    kacinci: Math.max(count, 1),
  });

  // Sitede geçirilen süre: sekme görünürken sayılır, sekme gizlenince
  // ya da kapanınca toplam backend'e bildirilir.
  let visibleMs = 0;
  let visibleSince = document.visibilityState === "visible" ? Date.now() : null;
  const reportTime = () => {
    if (visibleSince) {
      visibleMs += Date.now() - visibleSince;
      visibleSince = null;
    }
    if (visibleMs >= 5000) send("sure", String(Math.round(visibleMs / 1000)));
  };
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") reportTime();
    else visibleSince = Date.now();
  });
  window.addEventListener("pagehide", reportTime);

  // CV PDF'ine tıklanınca haber ver (hangi bileşende olursa olsun)
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest("a[href$='.pdf']");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      send("cv", /Resume_En/i.test(href) ? "İngilizce" : "Türkçe");
      store.set(LAST_KEY, String(Date.now()));
    },
    true
  );
}

/* Ziyaretçi başka bir sayfaya geçince çağrılır. */
export function trackPage(page) {
  if (!started || page === lastPage) return;
  lastPage = page;
  store.set(LAST_KEY, String(Date.now()));
  send("sayfa", page);
}
